import { render, staticRenderFns } from "./OwnWrite.vue?vue&type=template&id=c35cf0e6&scoped=true"
import script from "./OwnWrite.vue?vue&type=script&lang=js"
export * from "./OwnWrite.vue?vue&type=script&lang=js"
import style0 from "./OwnWrite.vue?vue&type=style&index=0&id=c35cf0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cf0e6",
  null
  
)

export default component.exports